import { institutionTypes } from '@/enums/institutionTypes'

const initialState = {
  id: 0,
  jobPositionAssignmentId: 0,
  institutionType: null,
  institution: null,
  bankType: null,
  companyType: null,
  ownershipType: null,
  individualReadOnly: 0,
  individualEdit: 0,
  institutionReadOnly: 0,
  institutionEdit: 0,
  isCbiPermission: false
}

const getDefaultState = (institutionPermission, isCbiPermission) => {
  return {
    ...initialState,
    ...institutionPermission,
    isCbiPermission
  }
}

const actionTypes = {
  institutionTypeChange: 'institutionTypeChange',
  institutionChange: 'institutionChange',
  bankTypeChange: 'bankTypeChange',
  companyTypeChange: 'companyTypeChange',
  ownershipTypeChange: 'ownershipTypeChange',
  individualReadOnlyChange: 'individualReadOnlyChange',
  individualEditChange: 'individualEditChange',
  institutionReadOnlyChange: 'institutionReadOnlyChange',
  institutionEditChange: 'institutionEditChange',
  clearStateInstitution: 'clearStateForInstitution',
  clearStateByFilter: 'clearStateForByFilter'
}

function reducer (state, action) {
  let institutionType
  switch (action.type) {
    case actionTypes.institutionTypeChange:
      institutionType = (action.data && action.data.value) || null

      if (institutionType === institutionTypes.enum.Bank) {
        return { ...state, institutionType, companyType: null }
      }

      if (institutionType === institutionTypes.enum.Company) {
        return { ...state, institutionType, bankType: null }
      }

      return { ...state, institutionType }
    case actionTypes.institutionChange:
      return { ...state, institution: action.data }
    case actionTypes.bankTypeChange:
      return { ...state, bankType: action.data }
    case actionTypes.companyTypeChange:
      return { ...state, companyType: action.data }
    case actionTypes.ownershipTypeChange:
      return { ...state, ownershipType: action.data }
    case actionTypes.individualReadOnlyChange:
      return { ...state, individualReadOnly: action.data }
    case actionTypes.individualEditChange:
      return { ...state, individualEdit: action.data }
    case actionTypes.institutionReadOnlyChange:
      return { ...state, institutionReadOnly: action.data }
    case actionTypes.institutionEditChange:
      return { ...state, institutionEdit: action.data }
    case actionTypes.clearStateInstitution:
      return { ...state, institutionType: null, bankType: null, companyType: null, ownershipType: null }
    case actionTypes.clearStateByFilter:
      return { ...state, institution: null }
  }
}

export {
  actionTypes,
  getDefaultState,
  reducer
}



// WEBPACK FOOTER //
// ./src/dialogs/institutionPermission/reducer.js